import { getModuleHero } from 'assets/content/landingPages/supplements';

export const getVariant = (variant: string | undefined) => {
  const moduleHero = getModuleHero();
  switch (variant) {
    case 'rootsource1':
      return {
        contentVariant: moduleHero.variant.rootsource1,
        testId: `supplements-landing-module-variant-supplements-${variant}`,
      };
    case 'rootsource2':
      return {
        contentVariant: moduleHero.variant.rootsource2,
        testId: `supplements-landing-module-variant-supplements-${variant}`,
      };
    case 'videostraight':
      return {
        contentVariant: moduleHero.variant.videostraight,
        testId: `supplements-landing-module-variant-supplements-${variant}`,
      };
    case 'videocurly':
      return {
        contentVariant: moduleHero.variant.videocurly,
        testId: `supplements-landing-module-variant-supplements-${variant}`,
      };
    case 'video3':
      return {
        contentVariant: moduleHero.variant.video3,
        testId: `supplements-landing-module-variant-supplements-${variant}`,
      };
    case 'pp':
      return {
        contentVariant: moduleHero.variant.postpartum,
        testId: `supplements-landing-module-variant-supplements-${variant}`,
      };
    default:
      return {
        contentVariant: moduleHero.variant.default,
        testId: `supplements-landing-module-default`,
      };
  }
};
